import { render } from "./ModalAnswer.vue?vue&type=template&id=8ccad728&scoped=true"
import script from "./ModalAnswer.vue?vue&type=script&lang=js"
export * from "./ModalAnswer.vue?vue&type=script&lang=js"

import "@/assets/styles/mystyles.css?vue&type=style&index=0&id=8ccad728&scoped=true&lang=css&external"
import "./ModalAnswer.vue?vue&type=style&index=1&id=8ccad728&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ccad728"]])

export default __exports__